export default __webpack_public_path__ + "static/media/close.fa4c8291.svg";